import { blastGalaxy } from './items/blast-galaxy';
import { vanWindNaarWatt } from './items/van-wind-naar-watt';
import { leNouTattou } from './items/le-nou-tattout';
import { haarlemseWinkels } from './items/haarlemse-winkels';

export const projectsList = [blastGalaxy, vanWindNaarWatt, haarlemseWinkels, leNouTattou];
